import { Controller } from "@hotwired/stimulus"

// 일 사용량 선택에 따라 일 최대 사용량 단위 옵션을 변경
export default class extends Controller {
  static targets = ["unitDropdown"]

  static UNITS = {
    small:  [{ value: "mg", label: "mg" }, { value: "g", label: "g" }, { value: "mL", label: "mL" }],
    medium: [{ value: "kg", label: "kg" }, { value: "L", label: "L" }],
    large:  [{ value: "ton", label: "ton" }, { value: "m3", label: "m³" }]
  }

  select(event) {
    const radio = event.target
    if (radio.type !== "radio") return

    const amount = radio.value
    const units = this.constructor.UNITS[amount]
    if (!units) return

    // 일 최대 사용량 row 표시
    const row = document.getElementById("daily-max-usage-row")
    if (row) row.classList.remove("hidden")

    // Fomantic UI dropdown 메뉴 재구성
    const wrapper = this.unitDropdownTarget
    const dropdownEl = wrapper.querySelector(".ui.dropdown") || wrapper
    const menu = dropdownEl.querySelector(".menu")
    const hiddenInput = dropdownEl.querySelector("input[type=hidden]")
    const textEl = dropdownEl.querySelector(".text, .default.text")

    // 현재 선택값이 새 옵션에 있는지 확인
    const currentValue = hiddenInput ? hiddenInput.value : ""
    const stillValid = units.some(u => u.value === currentValue)

    // 메뉴 아이템 재구성
    menu.innerHTML = units.map(u =>
      `<div class="item${u.value === currentValue && stillValid ? ' active selected' : ''}" data-value="${u.value}">${u.label}</div>`
    ).join("")

    // 선택값이 새 옵션에 없으면 초기화
    if (!stillValid) {
      if (hiddenInput) hiddenInput.value = ""
      if (textEl) {
        textEl.className = "default text"
        textEl.textContent = "단위"
      }
    }

    // Fomantic dropdown 재초기화
    if (typeof $ !== "undefined" && $(dropdownEl).dropdown) {
      $(dropdownEl).dropdown("refresh")
    }
  }
}
